const RELOAD_FLAG = 'amglobal_workspace_chunk_reload'

const CHUNK_LOAD_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'error loading dynamically imported module',
  'Loading chunk',
  'Loading CSS chunk',
] as const

/** True when a lazy route chunk 404'd — common after deploy with rsync --delete + a stale tab. */
export function isStaleChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : ''
  return CHUNK_LOAD_PATTERNS.some((pattern) => message.includes(pattern))
}

function reloadOnceForStaleChunks(): void {
  if (sessionStorage.getItem(RELOAD_FLAG)) return
  sessionStorage.setItem(RELOAD_FLAG, '1')
  window.location.reload()
}

/** Vite emits `vite:preloadError` when a hashed lazy chunk fails to load in production. */
export function registerChunkLoadRecovery(): void {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadOnceForStaleChunks()
  })
}

export function clearChunkLoadRecoveryFlag(): void {
  sessionStorage.removeItem(RELOAD_FLAG)
}

/** Wrap route lazy imports so chunk 404s trigger one automatic hard refresh. */
export async function importWithChunkReload<T>(importer: () => Promise<T>): Promise<T> {
  try {
    return await importer()
  } catch (error) {
    if (isStaleChunkLoadError(error)) {
      reloadOnceForStaleChunks()
      return new Promise<T>(() => {})
    }
    throw error
  }
}
